export const SUP_ONLINE_TOOLS_CROSSFLOW_FLOW_LOADER = {
  desktop: `
<div class="cui-grid cui-container">

  <!-- Breadcrumbs skeleton -->
  <div class="cui-skeleton-paragraph -spacing--top-64 -spacing--bottom-40">
    <div class="cui-skeleton-paragraph__content" style="width: 170px">
      <div class="cui-skeleton__item cui-skeleton__description" style="height: 26.281px;"></div>
    </div>
  </div>

  <!-- Title Skeleton -->
  <div class="cui-skeleton-heading -size--large -resolution--desktop -spacing--bottom-32">
    <div class="cui-skeleton-heading__content">
      <div class="cui-skeleton__item cui-skeleton-heading__title" style="height: 36px;"></div>
      <div class="cui-skeleton__item cui-skeleton__description -spacing--top-8" style="height: 101.672px;"></div>
    </div>
  </div>

  <!-- Content Skeleton -->
  <div class="cui-skeleton__item -spacing--bottom-120" style="width: 100%; height: 427.547px;"></div>

</div>
`
};
